export enum TipoEntidad {
  EMISOR = 1,
  ABSORBEDOR = 2
}
